<section class="main-section">
  <header class="d-flex justify-content-between align-items-center main-heading">
    <div class="d-flex align-items-center">
      <a class="btn btn-link me-3 p-0 d-block d-xl-none" data-bs-toggle="offcanvas" href="#offcanvasExample"
        role="button" aria-controls="offcanvasExample">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 7H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          <path d="M3 12H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          <path d="M3 17H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
        </svg></a>
      <h3 class="heading-span text-black">
        <span>Sector</span>
      </h3>
    </div>
    <!-- <div class="">
      <div class="d-flex">
        <button *ngIf="userRole?.includes(roles.SuperAdmin)" type="button" class="btn theme-btn px-2 px-md-4 ms-3"
          (click)="createSector()">Create
        </button>
      </div>
    </div> -->
  </header>
  <div *ngIf="loading==false && !sectors.length && userRole?.includes(roles.SuperAdmin)" class="create-block mw-100">
    <img alt="" class="" src="../assets/images/create-mat.svg" />
    <h3 class="my-4 pt-2 content-center">Create Sector</h3>
    <div class="d-flex flex-wrap justify-content-center">
      <button type="button" class="btn theme-btn px-5 me-0 me-sm-3 mb-4 ms-2" (click)="createSector()">
        Create Sector
      </button>
    </div>
  </div>
  <div class="sector-view" *ngIf="sectors.length">
    <div class="row">
      <div *ngFor="let sector of sectors" (click)="setSector(sector)" class="col-md-3 col-10 px-0 mx-2 h125 radius16 card-sector mb-2">
        <div class="d-flex m-4 mb-0">
          <span class="border-grey-c addsector-iconborder" style="height: 64px;width: 64px; " >
            @switch (sector.sectorName) {
              @case ('Education') {
                <mat-icon style="font-size: 42px; height: 48px; width: 48px;;vertical-align: middle;">school</mat-icon>
              }
              @case ('Housing') {
                <mat-icon style="font-size: 42px; height: 48px; width: 48px;;vertical-align: middle;">domain</mat-icon>
              }
              @default {
              <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.83 6.01002L13.28 0.770018C12 -0.249982 9.99996 -0.259982 8.72996 0.760018L2.17996 6.01002C1.23996 6.76002 0.669963 8.26002 0.869963 9.44002L2.12996 16.98C2.41996 18.67 3.98996 20 5.69996 20H16.3C17.99 20 19.59 18.64 19.88 16.97L21.14 9.43002C21.32 8.26002 20.75 6.76002 19.83 6.01002Z"
                fill="#fff"/>

              </svg>
              }
            }
          
        </span>
          <label class="fs24 fw450 color-black-pearl ml12 my-auto mat-account-detail" [matTooltip]="sector.sectorName">
            {{sector.sectorName}}
          </label>
        </div>
        <!-- <div class="row">
          <div class="col-md-5 col-3 px-0 text-center ms-0">
            <label class="text-underline">Click to open</label>
          </div>
          <div *ngIf="userRole?.includes(roles.SuperAdmin)" class="col-md-5 col-6 px-0 mx-0 text-end">
            <span class="border-grey-c" (click)="$event.stopPropagation();$event.preventDefault();editSector(sector)">
              <a class=""><svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.05 3.00002L4.20829 10.2417C3.94996 10.5167 3.69996 11.0584 3.64996 11.4334L3.34162 14.1333C3.23329 15.1083 3.93329 15.775 4.89996 15.6084L7.58329 15.15C7.95829 15.0834 8.48329 14.8084 8.74162 14.525L15.5833 7.28335C16.7666 6.03335 17.3 4.60835 15.4583 2.86668C13.625 1.14168 12.2333 1.75002 11.05 3.00002Z"
                    stroke="#4F6681" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M9.90845 4.20825C10.2668 6.50825 12.1334 8.26658 14.4501 8.49992" stroke="#4F6681"
                    stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M2.5 18.3333H17.5" stroke="#4F6681" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg></a>
            </span>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</section>